<script>
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "AppLayout",
  setup() {
    const route = useRoute();
    /**
     *  This is a computed property that will return the name
     *  of the current route
     */
    const layout = computed(() => {
      const layout = route?.meta?.layout;

      if (layout) {
        return `The${layout}Layout`;
      }
      return null;
    });
    return {
      layout,
    };
  },
};
</script>

<template>
  <component :is="layout">
  </component>
  
</template>
